 <template>
  <section class="content">
    <div class="row center-block" v-for="registro of registros"  :key="registro.label" v-if="registro.nivel.isNivel">
      <h3>{{registro.label}} <small>{{registro.data}} - {{registro.hora}}</small></h3>
      <div class="col-md-12">
        <div class="box">
          <div class="box-header">
            <h3 class="box-title">Informação</h3>
          </div>
          <!-- /.box-header -->
          <div class="box-body no-padding table-responsive">
            <table class="table table-striped">
              <tbody>
                <tr>
                  <th style="width: 10px">#</th>
                  <th>Função</th>
                  <th style="width: 40px">Valor</th>
                </tr>
                <tr>
                  <td>0</td>
                  <td>{{registro.nivel.label0}}</td>
                  <td>
                    <div>
                      <span class="badge bg-green" v-if="intToBinaryString(registro.valor)[7] === '1'">On</span>
                      <span class="badge" v-else>Off</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>{{registro.nivel.label1}}</td>
                  <td>
                    <div>
                      <span class="badge bg-green" v-if="intToBinaryString(registro.valor)[6] === '1'">On</span>
                      <span class="badge" v-else>Off</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>{{registro.nivel.label2}}</td>
                  <td>
                    <div>
                      <span class="badge bg-green" v-if="intToBinaryString(registro.valor)[5] === '1'">On</span>
                      <span class="badge" v-else>Off</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>{{registro.nivel.label3}}</td>
                  <td>
                    <div>
                      <span class="badge bg-green" v-if="intToBinaryString(registro.valor)[4] === '1'">On</span>
                      <span class="badge" v-else>Off</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>{{registro.nivel.label4}}</td>
                  <td>
                    <div>
                      <span class="badge bg-green" v-if="intToBinaryString(registro.valor)[3] === '1'">On</span>
                      <span class="badge" v-else>Off</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>{{registro.nivel.label5}}</td>
                  <td>
                    <div>
                      <span class="badge bg-green" v-if="intToBinaryString(registro.valor)[2] === '1'">On</span>
                      <span class="badge" v-else>Off</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>{{registro.nivel.label6}}</td>
                  <td>
                    <div>
                      <span class="badge bg-green" v-if="intToBinaryString(registro.valor)[1] === '1'">On</span>
                      <span class="badge" v-else>Off</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>7</td>
                  <td>{{registro.nivel.label7}}</td>
                  <td>
                    <div>
                      <span class="badge bg-green" v-if="intToBinaryString(registro.valor)[0] === '1'">On</span>
                      <span class="badge" v-else>Off</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- /.box-body -->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import $ from 'jquery'
// Require needed datatables modules
import 'datatables.net'
import 'datatables.net-bs'
import {db} from '../../firebase'

export default {
  name: 'Manutencao',
  data () {
    return {
      registros: {}
    }
  },
  firebase: {
    registros: {
      source: db.ref('registradoronline'),
      cancelCallback (err) {
        console.error(err)
      }
    }
  },
  methods: {
    intToBinaryString: function (number) {
      var result = number.toString(2)
      while (Math.floor(result.length % 8) !== 0) {
        result = '0' + result
      }
      return result
    }
  },
  mounted () {
    this.$nextTick(() => {
      $('#example1').DataTable()
    })
  }
}
</script>

<style>
/* Using the bootstrap style, but overriding the font to not draw in
   the Glyphicons Halflings font as an additional requirement for sorting icons.

   An alternative to the solution active below is to use the jquery style
   which uses images, but the color on the images does not match adminlte.

@import url('/static/js/plugins/datatables/jquery.dataTables.min.css');
*/

@import url('/static/js/plugins/datatables/dataTables.bootstrap.css');

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: 'FontAwesome';
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
}
</style>



// WEBPACK FOOTER //
// Manutencao.vue?ee302a3e